import {
    AfterContentInit,
    Component,
    ComponentRef,
    ContentChildren,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {MvsObjectNavigationService} from "../../../navigation/mvs-object-navigation.service";
import {OverviewPageComponent} from "../../../components/mvs-overview-page/overview-page.component";
import {MvsObjectNavigationProviderOb} from "../../../navigation/impl/mvs-object-navigation-provider-ob";
import {MvsObjectNavigationEntry} from "../../../navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../navigation/mvs-object-navigation-action-enum";
import {MvsWidgetComponent} from "../../../widget/component/runtime/mvs-widget/mvs-widget.component";
import {DtoImportObjectContextEntry} from "../../../dto/dto.import.object.context.entry";
import {DtoImportObjectContext} from "../../../dto/dto.import.object.context";
import {FilterCriteria} from "../../../filter/api/filter.criteria";
import {ObjectChangeInformation, ObjectChangeInformationActionEnum} from "../../../logic/object-change-information";
import {WidgetData} from "../../../widget/widget-data";
import {MvsObjectNavigationNode} from "../../../navigation/mvs-object-navigation-node";
import {ObjectRequestList} from "../../../dto/object/request/object-request-list";
import {PagingDto} from "../../../dto/model/paging.dto";
import {MvsTemplateDirective} from "../../../templating/directive/mvs-template.directive";
import {ObjectIdentifier} from "../../../basic/object-identifier";
import {MvsCoreService} from "../../../service/mvs-core.service";
import {ObjectIdentifierData} from "../../../basic/object-identifier-data";
import {ObjectTypeId} from "../../../logic/object-type-id";
import {ObjectBrowserRequestDto} from "../../../object/dto/object-browser-request.dto";
import {ObjectBrowserResultDto} from "../../../object/dto/object-browser-result.dto";
import {ObjectBrowserResultEntryDto} from "../../../object/dto/object-browser-result-entry.dto";
import {ObjectBrowserService} from "../../../object/service/api/object-browser.service";
import {ObjectBrowserRequestEntryDto} from "../../../object/dto/object-browser-request-entry.dto";
import {Popover} from "primeng/popover";

//DEPRECATED
@Component({
    selector: 'mvs-crud-page',
    templateUrl: './mvs-crud-page.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MvsCrudPageComponent extends OverviewPageComponent implements OnInit, AfterContentInit {

    @ContentChildren(MvsTemplateDirective) templates: QueryList<MvsTemplateDirective>;

    templateMainBegin: MvsTemplateDirective;
    templateMainEnd: MvsTemplateDirective;

    @Input() override defaultLabel: string;

    @Input() objectStructureRequest: ObjectBrowserRequestDto
    objectStructureResult: ObjectBrowserResultDto

    @Output() onMainSelectedObjectChange = new EventEmitter<ObjectTypeId>()
    @Output() onChangedObject = new EventEmitter<ObjectChangeInformation>();

    // main object that should be processed within the PageComponent
    @Input() mainObjectType: string;
    @Input() mainObjectTypeStructureRequest: ObjectBrowserRequestDto

    @Input() noInit: boolean

    @Input() useOnlyRegularCrudComponent: boolean = false;

    @Input() mainObjectSideNavigationNeverVisible: boolean = false;

    /*
    selectedObject: ObjectBrowserResultEntryDto
    selectedNode: TreeNode
    selectedSubObject: ObjectBrowserResultEntryDto
    selectedSubNode: TreeNode
     */

    mainObjectSelected: ObjectIdentifier;
    mainObjectStructureResult: ObjectBrowserResultDto
    mainObjectSubObjectSelected: ObjectBrowserResultEntryDto;
    mainObjectImportObjectContext: DtoImportObjectContext;

    // UI
    uiStructureTreeVisible: boolean = true;

    // UI Fields connected with the Main ObjectAlias Processing
    uiMainObjectAliasStructureTreeVisible: boolean = false;

    mode: string;
    showMainTemplates: boolean = false;

    // show all entities
    widgetEntityTable: WidgetData;

    // crud show
    crudObjectShow: boolean = false;
    crudObjectType: string;
    crudObjectId: number;
    crudObjectImportObjectContext: DtoImportObjectContext;

    // card show
    cardEntries: any[];

    // create actions

    @ViewChild('opCreateActions') actionCreateOverlayPanel: Popover;

    actionCreateShow: boolean;
    actionCreateMenu: MenuItem[];

    showNavigation: boolean = true;
    @Input() showActionBar: boolean = true;
    @Input() showCardEntries: boolean = true;

    @ViewChild('pageWidgetContainer', {
        read: ViewContainerRef,
        static: true
    }) widgetContainer: ViewContainerRef | undefined;

    constructor(
        protected override route: ActivatedRoute,
        protected objectBrowserService: ObjectBrowserService,
        protected override navigationService: MvsObjectNavigationService,
        protected override router: Router,
        protected override coreService: MvsCoreService) {

        super(route, navigationService, router, coreService);
    }


    override ngOnInit(): void {
        super.ngOnInit();
        if (!this.noInit) {
            this.init();
        }

    }


    ngAfterContentInit() {
        // contentChildren is set
        this.refreshTemplates();
    }

    init() {

        // create navigation context
        this.refreshNavigation(null)


    }

    refreshTemplates() {
        this.templateMainEnd = null;
        this.templateMainBegin = null;

        if (this.templates && this.templates.length > 0) {

            for (let template of this.templates) {
                if (template.area == "main-body:begin") {
                    this.templateMainBegin = template;
                } else if (template.area == "main-body:end") {
                    this.templateMainEnd = template;
                }
            }
        }

    }


    /**
     *
     * @param event
     */
    onObjectStructureSubNodeSelect(event: any) {
        this.changeSubSelection(event.node)
    }

    /**
     * Change navigation object.
     * @param event
     */
    onObjectStructureNodeSelect(event: any) {
        this.onNavigationObjectChanged(event.node)
    }


    /**
     * The selection of the SUB object has changed.
     * @param selectedObject
     */
    changeSubSelection(selectedObject: ObjectBrowserResultEntryDto) {

        // check whether this is a dummy entry only for hierarchy purposes
        if (!selectedObject.objectId && !selectedObject.createEntry) {
            return;
        }

        // change the current CRUD object
        if (selectedObject.createEntry) {
            this.crudObjectId = null;
            this.mode = 'entity.crud.object.create';
        } else {
            this.crudObjectId = selectedObject.objectId;
            this.mode = 'entity.crud.object';
        }

        this.crudObjectType = selectedObject.objectAlias;
        this.crudObjectImportObjectContext = this.mainObjectImportObjectContext.copy();

        let parentRequests = this.extractEntriesFromObjectStructureResult(this.mainObjectStructureResult, selectedObject);

        for (let parentRequest of parentRequests) {
            if (ObjectBrowserResultEntryDto.isActualObject(parentRequest)) {
                this.crudObjectImportObjectContext.addEntry(new DtoImportObjectContextEntry(parentRequest.objectAlias, parentRequest.objectId, parentRequest.parentAttributeName));
            }
        }


        if (!ObjectBrowserResultEntryDto.equalsStatic(this.mainObjectSubObjectSelected, selectedObject)) {
            this.mainObjectSubObjectSelected = selectedObject;
        }

    }


    /**
     * The selection of the MAIN object has changed and the ImportObjectContext needs to be re-processed.
     * @param selectedObject
     */
    onNavigationObjectChanged(navigationEntry: MvsObjectNavigationEntry) {

        // decide what needs to be rendered
        const navigationProvider = this.navigationService.getNavigationProvider().getValue();

        // get next navigation level
        const objectIdentifier = (!navigationEntry ? null : navigationEntry.objectIdentifier);
        const navigationNode = navigationProvider.getNavigationEntriesFromObject(objectIdentifier, 1);

        // keep the action
        if (navigationEntry) {
            navigationNode.nodeElement.action = navigationEntry.action;
        }

        // decide what needs to be rendered
        if (!objectIdentifier) {
            // root entries need to be rendered
            this.renderMode("root", navigationNode);

        } else if (navigationEntry.objectIdentifier.objectType == this.mainObjectType && navigationEntry.objectIdentifier.objectId && navigationEntry.objectIdentifier.navigationType === "object") {

            // changed to main object type !
            //this.renderMode("entity.main.object", navigationNode);
            this.renderMode("entity.crud.object", navigationNode);

        } else if (navigationEntry.objectIdentifier.objectType && !navigationEntry.objectIdentifier.objectId && navigationEntry.action && navigationEntry.action === MvsObjectNavigationActionEnum.create) {

            // create mode
            this.renderMode("entity.crud.object.create", navigationNode);

        } else if (navigationNode.nodeLevel == 1 && navigationEntry.objectIdentifier.objectType && !navigationEntry.objectIdentifier.objectId) {

            // An object type was selected on the highest level, so we'll show a table widget containing all entries
            this.renderMode("entity.table", navigationNode);

        } else if (navigationEntry.objectIdentifier.objectType && navigationEntry.objectIdentifier.objectId) {

            // A specific object was selected, so we'll show the mvs-crud-object component, to enable the data entry
            this.renderMode("entity.crud.object", navigationNode);
        } else {
            console.log("not supported!");
        }

        // inform underlying components about the new MAIN object
        // this.refreshCrudComponents()

    }

    onObjectSelectWidgetTable(event: ObjectIdentifierData | ObjectIdentifier) {
        this.navigationService.navigateTo(MvsObjectNavigationEntry.createNavigationEntry(event.objectType, event.objectId, "", "", "", "", MvsObjectNavigationActionEnum.edit));

    }

    renderMode(mode: string, navigationNode: MvsObjectNavigationNode) {

        // default mode with requested mode
        this.mode = mode;

        // init all the UI controls
        this.widgetEntityTable = null;
        this.crudObjectShow = false;
        this.cardEntries = [];
        this.actionCreateShow = false;
        this.actionCreateMenu = [];
        this.showMainTemplates = false;

        this.showNavigation = true;


        switch (mode) {
            case "entity.table":
                this.renderWidgetTable(navigationNode);
                break;
            case "entity.crud.object":
                this.renderCrudObject(navigationNode);

                if (!navigationNode.entries || navigationNode.entries.length == 0) {
                    this.showNavigation = false;
                }

                break;
            case "entity.crud.object.create":
                this.renderCrudObject(navigationNode);
                break;
            case "root":

                if (navigationNode.entries.length > 0) {

                    // only object types exist -> show Cards
                    this.mode = "root.cards";
                    this.renderCards(navigationNode);
                    this.showMainTemplates = true;
                }
                break;
        }

        // calculate whether create should be available
        const createObjectTypes: MvsObjectNavigationEntry[] = [];

        if (navigationNode.nodeElement && navigationNode.nodeElement.objectIdentifier && navigationNode.nodeElement.objectIdentifier.objectType) {
            // object type was specified, make sure that there is no object id
            if (!navigationNode.nodeElement.objectIdentifier.objectId) {
                createObjectTypes[navigationNode.nodeElement.objectIdentifier.objectType] = navigationNode.nodeElement;
                this.actionCreateShow = true;
            }
        } else if (navigationNode.entries && navigationNode.entries.length > 0) {
            // check lower levels
            for (let entry of navigationNode.entries) {

                if (entry.objectIdentifier && entry.objectIdentifier.objectType && !entry.objectIdentifier.objectId) {
                    createObjectTypes[entry.objectIdentifier.objectType] = entry;
                    this.actionCreateShow = true;
                }

            }
        }

        if (this.actionCreateShow) {
            for (const createObjectType in createObjectTypes) {
                const entry = createObjectTypes[createObjectType];

                const createEntry = MvsObjectNavigationEntry.clone(entry);
                createEntry.action = MvsObjectNavigationActionEnum.create;

                this.actionCreateMenu.push({
                    label: entry.name,
                    icon: "fa-regular fa-circle-plus",
                    command: (event) => {
                        this.actionCreateOverlayPanel.hide();
                        this.changeNavigationEntry(createEntry);
                    }
                });

            }
        }

    }

    renderCards(navigationNode: MvsObjectNavigationNode) {

        for (let entry of navigationNode.entries) {

            this.cardEntries.push({
                header: entry.name,
                entry: entry,
                description: entry.description,
                image: entry.image
            });
        }


    }

    renderCrudObject(navigationNode: MvsObjectNavigationNode) {

        this.crudObjectShow = true;
        this.crudObjectType = navigationNode.nodeElement.objectIdentifier.objectType;

        if (navigationNode.nodeElement.action == MvsObjectNavigationActionEnum.create) {
            this.crudObjectId = 0;
        } else {
            this.crudObjectId = navigationNode.nodeElement.objectIdentifier.objectId;
        }

        // the import object context needs to be derived using the navigation path
        const navigationProviderInterface = this.navigationService.getNavigationProvider().getValue();

        const navigationPath = navigationProviderInterface.getNavigationPath(navigationNode.nodeElement.objectIdentifier);

        // collect objects and store within ImportObjectContext!
        const dtoImportObjectContext = new DtoImportObjectContext([]);

        for (let pathEntry of navigationPath) {

            if (pathEntry.objectIdentifier.objectType && pathEntry.objectIdentifier.objectId) {

                if (this.crudObjectType != pathEntry.objectIdentifier.objectType || this.crudObjectId != pathEntry.objectIdentifier.objectId) {
                    const contextEntry = new DtoImportObjectContextEntry(pathEntry.objectIdentifier.objectType, pathEntry.objectIdentifier.objectId, null);
                    dtoImportObjectContext.addEntryAndReplaceType(contextEntry);
                }

            }

        }

        this.crudObjectImportObjectContext = dtoImportObjectContext;

        // check whether main object is processed and refresh sub structure if needed
        this.mainObjectSelected = null;

        if (this.crudObjectId != 0 && this.crudObjectType === this.mainObjectType) {
            this.mainObjectSelected = new ObjectIdentifier(this.crudObjectType, this.crudObjectId);

            // create specific import object context
            this.mainObjectImportObjectContext = this.crudObjectImportObjectContext.copy();
            this.mainObjectImportObjectContext.addEntry(new DtoImportObjectContextEntry(this.crudObjectType, this.crudObjectId, null));

            this.refreshSubStructure(this.crudObjectImportObjectContext, true, null);
        } else {
            // hide
        }


    }

    renderWidgetTable(navigationNode: MvsObjectNavigationNode) {
        //this.widgetUnassignedDocumentsFilter = FilterCriteriaCollection.createFromFilterCriteria([ FilterCriteria.create("dmDocumentStorage", FilterCriteria.cOperatorEqual, this.defaultStorageDto["id"], null) ]);

        this.widgetEntityTable = new WidgetData();
        this.widgetEntityTable.id = 1;
        this.widgetEntityTable.idAlias = "crud.page.table.object.type." + navigationNode.nodeLevel + "." + navigationNode.nodeElement.objectIdentifier.objectType;
        this.widgetEntityTable.name = navigationNode.nodeElement.name;
        this.widgetEntityTable.uiComponent = "table";
        this.widgetEntityTable.dataProvider = "list";
        this.widgetEntityTable.dataSource = "entity";
        this.widgetEntityTable.dataProviderObject = navigationNode.nodeElement.objectIdentifier.objectType;

        // check whether a filter is required
        if (navigationNode.nodeLevel == 1) {
            // use filter from request item (if any exists)
            const obRequest = this.objectStructureRequest.entries.find(value => value.objectAlias == navigationNode.nodeElement.objectIdentifier.objectType);

            if (obRequest) {
                this.widgetEntityTable.dataProviderListRequest = ObjectRequestList.createWithPaging(true, obRequest.filterCriteria, obRequest.sortingList, PagingDto.create(0, 20));
            } else {
                this.widgetEntityTable.dataProviderListRequest = ObjectRequestList.createWithPaging(true, [], [], PagingDto.create(0, 20));
            }

        } else {

            const filterByIds: FilterCriteria[] = [];

            // create filter criteria based on the IDs of the next level
            for (let entry of navigationNode.entries) {
                filterByIds.push(FilterCriteria.create("id", FilterCriteria.cOperatorEqual, entry.objectIdentifier.objectId, null));
            }
            this.widgetEntityTable.dataProviderListRequest = ObjectRequestList.createWithPaging(true, filterByIds, [], PagingDto.create(0, 20));

        }

        this.widgetEntityTable.setParamValue("selectionMode", "single");
        this.widgetEntityTable.setParamValue("size", "S");

        this.createWidget();

    }

    changeNavigationEntry(navigationEntry: MvsObjectNavigationEntry) {
        this.navigationService.navigateTo(navigationEntry);
    }


    /**
     * This method is used to refresh the sub structure whenever the main object may change
     */
    refreshSubStructure(dtoImportObjectContext: DtoImportObjectContext, forceRefresh: boolean, newSubSelection: ObjectBrowserResultEntryDto) {

        let expandedObjects = null;


        // check whether the main object alias was set
        if (!this.mainObjectType || !this.mainObjectTypeStructureRequest) {
            return; // no processing required as MainObjectAlias was not provided
        }


        // store expanded Objects
        if (this.mainObjectStructureResult) {
            expandedObjects = this.mainObjectStructureResult.getExpandedObjects();
        }


        // hide MainObjectAlias
        this.uiMainObjectAliasStructureTreeVisible = false;

        if (this.mainObjectSelected.objectType !== this.mainObjectType && !forceRefresh) {
            // a different objectAlias was selected, so we can disable the MainObject processing
            this.uiMainObjectAliasStructureTreeVisible = false;
        } else {

            // in case of a new object, we must not refresh the sub structure and clear it
            if (!this.mainObjectSelected.objectId) {
                return;
            }

            // we need to refresh the tree using the new import object context
            const request = this.getObjectStructureRequest(
                this.mainObjectTypeStructureRequest,
                null
            );

            // add filter to only return the main object entries
            for (let entry of request.entries) {
                if (entry.objectAlias === this.mainObjectType) {
                    entry.filterCriteria = [
                        FilterCriteria.createSingleCondition("id", FilterCriteria.cOperatorEqual, this.mainObjectSelected.objectId, 0)
                    ]
                }
            }

            this.objectBrowserService.getGenerateObjectBrowser(request).subscribe(value => {
                let objectStructureResult: ObjectBrowserResultDto = new ObjectBrowserResultDto();

                Object.assign(objectStructureResult, value);

                // we have to remove the root level, because the root contains the processed object and is therefore not relevant
                try {
                    objectStructureResult.root.entries = objectStructureResult.root.entries[0].entries;
                } catch (e) {
                    // no entries exist
                }

                this.objectBrowserService.convertObjectBrowserToTreeModel(objectStructureResult, expandedObjects);
                this.mainObjectStructureResult = objectStructureResult;

                if (!this.mainObjectSideNavigationNeverVisible) {
                    this.uiMainObjectAliasStructureTreeVisible = true;
                } else {
                    this.uiMainObjectAliasStructureTreeVisible = false;
                }

                if (newSubSelection) {

                    // check whether the sub object was not fully passed and if so, retrieve the full object
                    if (!newSubSelection.objectName) {
                        let objectBrowserResultEntries = this.extractEntriesFromObjectStructureResult(this.mainObjectStructureResult, newSubSelection);

                        if (objectBrowserResultEntries && objectBrowserResultEntries.length >= 1) {
                            for (let objectBrowserResultEntry of objectBrowserResultEntries) {

                                if (ObjectBrowserResultEntryDto.equalsStatic(objectBrowserResultEntry, newSubSelection)) {
                                    newSubSelection = objectBrowserResultEntry;
                                    break;
                                }

                            }
                        }
                    }

                    this.changeSubSelection(newSubSelection);
                }

            });

        }

    }

    removeImportObjectContextEntry(event: any) {
        // implementation missing

        //super.removeImportObjectContextEntry(event)
    }

    /**
     * Extract the relevant request entries based on a selectedObject.
     * @param selectedObject
     */
    extractEntriesFromObjectStructureRequest(
        objectRequestStructure: ObjectBrowserRequestDto,
        selectedObject: ObjectBrowserResultEntryDto): ObjectBrowserRequestEntryDto[] {

        let requestEntries: ObjectBrowserRequestEntryDto[] = [];

        // Retrieve all relevant entries
        let mapParentIds = [];

        // retrieve all entries belonging to the hierarchy of the selected entry (upwards)
        for (let i = objectRequestStructure.entries.length - 1; i >= 0; i--) {
            const entry = objectRequestStructure.entries[i];

            // check whether this entry is a parent along the structure
            if (mapParentIds[entry.id] || entry.objectAlias === selectedObject.objectAlias) {
                // store at first position
                requestEntries.splice(0, 0, entry);

                // add parentID of this parent (if it exists)
                if (entry.parentId) {
                    mapParentIds[entry.parentId] = true;
                }
            }
        }

        // retrieve all entries belonging to the selected object downwards
        let selectedRequestedEntry = null;
        mapParentIds = [];

        for (let i = 0; i < objectRequestStructure.entries.length; i++) {
            const entry = objectRequestStructure.entries[i];

            // check whether this entry is a parent along the structure
            if (mapParentIds[entry.parentId] || entry.objectAlias === selectedObject.objectAlias) {

                // store entry, but only if it is not the selected object
                if (entry.objectAlias !== this.mainObjectSelected.objectType) {
                    requestEntries.push(entry);
                }

                // add id as possible parent
                mapParentIds[entry.id] = true;
            }
        }


        // return request entries to caller. The entries are already sorted using the proper hierarchy
        return requestEntries;
    }

    /**
     * Retrieve all result objects within the tree belonging the to the selected object.
     * @param objectRequestStructure
     * @param selectedObject
     */
    extractEntriesFromObjectStructureResult(
        objectResultStructure: ObjectBrowserResultDto,
        selectedObject: ObjectBrowserResultEntryDto): ObjectBrowserResultEntryDto[] {

        let selectedObjectHierarchy: ObjectBrowserResultEntryDto[] = this.findEntryWithinObjectStructureResult(objectResultStructure.root, selectedObject);

        return selectedObjectHierarchy;

    }

    /**
     * Find selected result entry within the ResultEntry Hierarchy.
     * @param objectBrowserResultEntry
     * @param selectedObject
     */
    findEntryWithinObjectStructureResult(
        objectBrowserResultEntry: ObjectBrowserResultEntryDto,
        selectedObject: ObjectBrowserResultEntryDto): ObjectBrowserResultEntryDto[] {

        let selectedObjectResultHierarchy: ObjectBrowserResultEntryDto[] = [];

        // search within the direct entries
        if (objectBrowserResultEntry.children) {
            for (let entry of objectBrowserResultEntry.children) {
                if (ObjectBrowserResultEntryDto.equalsStatic(entry, selectedObject)) {
                    selectedObjectResultHierarchy.push(entry);
                    break;
                }
            }

        }

        // if nothing was found, we'll call this method for the sub entries
        if (selectedObjectResultHierarchy.length === 0 && objectBrowserResultEntry.children) {

            for (let entry of objectBrowserResultEntry.children) {

                let selectedObjectResultHierarchySub = this.findEntryWithinObjectStructureResult(entry, selectedObject);

                if (selectedObjectResultHierarchySub.length > 0) {
                    selectedObjectResultHierarchy = selectedObjectResultHierarchySub;
                }
            }
        }

        if (selectedObjectResultHierarchy.length > 0) {
            // add myself as well, as I'm a parent too
            selectedObjectResultHierarchy.push(objectBrowserResultEntry);
        }

        return selectedObjectResultHierarchy;

    }


    /**
     * Convert imported ObjectStructureRequest into the proper type.
     */
    getObjectStructureRequest(
        importedObjectStructureRequest: ObjectBrowserRequestDto,
        dtoImportObjectContext: DtoImportObjectContext): ObjectBrowserRequestDto {

        let request: ObjectBrowserRequestDto = new ObjectBrowserRequestDto()
        request.dtoImportObjectContext = dtoImportObjectContext;
        request.extractDto = importedObjectStructureRequest.extractDto;
        request.createMode = importedObjectStructureRequest.createMode;
        request.entries = [];
        request.path = importedObjectStructureRequest.path;

        if (importedObjectStructureRequest.entries) {
            for (let entry of importedObjectStructureRequest.entries) {
                if (!entry["noTree"]) {
                    request.entries.push(entry);
                }
            }
        }

        return request;

    }


    /**
     * Refresh Object Navigation Structure.
     * @param selectedObject
     */
    refreshNavigation(selectedObject: ObjectBrowserResultEntryDto) {

        let expandedObjects = null;

        // store expanded Objects
        if (this.objectStructureResult) {
            expandedObjects = this.objectStructureResult.getExpandedObjects();
        }

        // retrieve request
        const request = this.getObjectStructureRequest(
            this.objectStructureRequest,
            this.objectStructureRequest.dtoImportObjectContext);

        if (request.entries.length == 0) {
            this.uiStructureTreeVisible = false
            return;
        }

        this.objectBrowserService.getGenerateObjectBrowser(request).subscribe(value => {

            let objectStructureResult: ObjectBrowserResultDto = new ObjectBrowserResultDto();
            Object.assign(objectStructureResult, value);

            this.objectBrowserService.convertObjectBrowserToTreeModel(objectStructureResult, expandedObjects);
            this.objectStructureResult = objectStructureResult;

            // change navigation provider
            this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderOb(this.objectStructureResult));

            if (!this.navigationObject) {
                this.navigationObject = this.navigationService.getNavigationObject();
                this.navigationObject.subscribe(navObject => {

                    if (navObject) {

                        const objectBrowserResultEntryDto = this.objectStructureResult.findResulEntry(navObject.objectIdentifier.objectType, navObject.objectIdentifier.objectId);

                        if (objectBrowserResultEntryDto) {
                            this.onNavigationObjectChanged(navObject);
                        } else {
                            console.error("navigation item not found", navObject);
                        }

                    } else {
                        this.onNavigationObjectChanged(navObject);
                    }
                });
            } else if (selectedObject) {
                this.navigationService.navigateTo(
                    MvsObjectNavigationEntry.createNavigationEntry(selectedObject.objectAlias, selectedObject.objectId, MvsObjectNavigationProviderOb.getNavigationType(selectedObject), selectedObject.objectName, null, null, MvsObjectNavigationActionEnum.any));
            }

        });

    }


    /**
     * Object Changed.
     * @param dtoDetail
     */
    onObjectChanged(objectChangeInformation: ObjectChangeInformation) {


        // check where this object type is located and perform a refresh
        if (this.objectStructureRequest && this.objectStructureRequest.entries) {

            let found: boolean = false;

            for (let entry of this.objectStructureRequest.entries) {
                if (entry.objectAlias == objectChangeInformation.objectType) {
                    found = true;
                    break;
                }
            }

            if (found) {

                const selectedObject = new ObjectBrowserResultEntryDto();

                switch (objectChangeInformation.action) {
                    case ObjectChangeInformationActionEnum.deleted:

                        selectedObject.createEntry = true;
                        selectedObject.objectAlias = objectChangeInformation.objectType;

                        this.refreshNavigation(selectedObject);

                        break;
                    case ObjectChangeInformationActionEnum.updated:

                        this.refreshNavigation(selectedObject);

                        break;
                    case ObjectChangeInformationActionEnum.created:

                        selectedObject.createEntry = false;
                        selectedObject.objectId = objectChangeInformation.after["id"];
                        selectedObject.objectAlias = objectChangeInformation.objectType;

                        this.refreshNavigation(selectedObject);

                        break;
                }

                return; // stop further processing
            } else {

                const selectedSubObject = new ObjectBrowserResultEntryDto();

                switch (objectChangeInformation.action) {
                    case ObjectChangeInformationActionEnum.deleted:

                        selectedSubObject.createEntry = true;
                        selectedSubObject.objectAlias = objectChangeInformation.objectType;

                        break;
                    case ObjectChangeInformationActionEnum.updated:

                        break;
                    case ObjectChangeInformationActionEnum.created:

                        selectedSubObject.createEntry = false;
                        selectedSubObject.objectId = objectChangeInformation.after["id"];
                        selectedSubObject.objectAlias = objectChangeInformation.objectType;

                        break;
                }


                // change the sub selection
                this.changeSubSelection(selectedSubObject)

                // refresh sub structure
                this.refreshSubStructure(this.importObjectContextDto, true, selectedSubObject);
            }
        }


    }

    override isConfigurationPage(): boolean {
        return true;
    }


    createWidget() {
        // if (!this.widgetContainer) {
        //   console.error('widgetContainer is not defined.');
        //   return;
        // }

        const componentRef: ComponentRef<MvsWidgetComponent> = this.widgetContainer.createComponent(MvsWidgetComponent);

        // Pass data to the component's @Input() properties
        componentRef.instance.widgetData = this.widgetEntityTable;

        // Subscribe to the component's @Output() event
        componentRef.instance.onObjectSelect.subscribe((event: ObjectIdentifierData | ObjectIdentifier) => this.onObjectSelectWidgetTable(event));
    }

}
